import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "char" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = ["onClick"]

import { computed, onMounted, ref } from 'vue';
import { request } from '../../../api/request';
import type { District, WebBasicBizAddressGetMultiLevelSubListOut } from '../../../api/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'province-panel',
  emits: ['select'],
  setup(__props, { expose: __expose, emit: __emit }) {

const provinceList = ref<WebBasicBizAddressGetMultiLevelSubListOut['districtList']>([])
const currentProvinceId = ref('')

const emit = __emit

const keys = [
  ['A', 'F'],
  ['G'],
  ['H', 'I'],
  ['J', 'R'],
  ['S', 'W'],
  ['X', 'Z']
]

const selectItem = (item) => {
  console.log(item, '省')
  currentProvinceId.value = item.districtID
  emit('select', item)
}

onMounted(async () => {
  const data = await request("web.basicBiz.address.getMultiLevelSubList", {
    districtLevel: 'province'
  })
  provinceList.value = data.districtList || []
})

const groups = computed(() => {
  return keys.reduce((result, k) => {
    const list = provinceList.value.filter(p => {
      return k.length > 1 ? k[0] <= p.initials && k[1] >= p.initials : k[0] === p.initials
    })
    return { ...result, [k.join('-')]: list }
  }, {} as Record<string, District[]>)
})

__expose({
  reset: () => currentProvinceId.value = ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(groups.value).sort(), (k) => {
      return (_openBlock(), _createElementBlock("div", {
        key: k,
        class: "group"
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(k), 1),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value[k], (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.districtID,
              class: _normalizeClass(['district', item.districtID === currentProvinceId.value ? 'active' : '']),
              onClick: ($event: any) => (selectItem(item))
            }, _toDisplayString(item.districtName), 11, _hoisted_3))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}
}

})